document.addEventListener("DOMContentLoaded", function () {
  const cta = document.getElementById("sticky-cta");
  const buyButton = document.querySelector('.buy-now-btn');
  const stickyBtn = cta?.querySelector(".cta-button");
  const priceDisplay = document.getElementById('sticky-cta-price');

  if (!cta || !buyButton || !stickyBtn) {
    console.warn("CTA or Buy button not found");
    return;
  }

  // Observer pour afficher ou cacher le sticky CTA
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          cta.classList.remove("show");
        } else {
          cta.classList.add("show");
        }
      });
    },
    {
      root: null,
      threshold: 0,
      rootMargin: '0px 0px -100px 0px'
    }
  );

  observer.observe(buyButton);

  // Clique sur le bouton principal
  stickyBtn.addEventListener("click", (e) => {
    e.preventDefault();
    buyButton.click();
  });

  // Mise à jour du prix et de l'ID de la variante
  document.addEventListener('variant:change', function (event) {
    const variant = event.detail.variant;

    if (variant && variant.available) {
      // Met à jour le prix affiché
      if (priceDisplay) {
        priceDisplay.textContent = (variant.price / 100).toFixed(2).replace('.', ',') + ' €';
      }

      // Met à jour l'attribut data-variant-id du bouton sticky
      stickyBtn.setAttribute("data-variant-id", variant.id);
    }
  });
});
